import { DictionaryType } from '../../../models/types/dictionary.type';
import { ModelTypes } from './model.types';

/**
 * This is only about the angular client routes, not about the api routes.
 */
export class RouteMapper {
    static get routesByType(): DictionaryType<string> {
        const dict: DictionaryType<string> = {};

        dict[ModelTypes.shareholders] = '/shareholders';
        dict[ModelTypes.shareholdersSummary] = '/shareholders';
        dict[ModelTypes.gmShareholdersSummary] = '/general-meeting/shareholders';
        dict[ModelTypes.traders] = '/traders';
        dict[ModelTypes.tradersSummary] = '/traders';
        dict[ModelTypes.transactions] = '/transactions';
        dict[ModelTypes.transactionsSummary] = '/transactions';
        dict[ModelTypes.users] = '/settings/users';
        dict[ModelTypes.reports] = '/reports';

        return dict;
    }
}
